<div class="panel fx-column">
  <div class="fx-row align-items-center justify-content-start">
    <img src="/assets/img/logo.svg" height="60">
  </div>
  <div class="fx-column fx-flex-100 align-items-center justify-content-center">
    <span class="title main bold">{{'LOGIN.TITLE' | translate}}</span>
    <span class="text">{{'LOGIN.SIGNING_IN' | translate}}</span>
  </div>
  <div class="fx-column align-items-center justify-content-center">
    <img src="/assets/icons/icon.svg" height="50" class="mb-10">
    <a class="main">uz-ip.tech</a>
  </div>
</div>
